/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

// add dialog
import { sha3_512 } from 'js-sha3';

import store from '../../../components/stores/Store';
import { updateMyInfo } from '../../../db/SystemOperationRequestHandler';
import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";


const styles = {
  root: {
    width: '70%',
    margin: 'auto'
  },
  button: {
    marginTop: '10px',
    width: '70%',
  }
};

class UserInfoManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      password: '',
      passwordConfirm: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.updateMyInfo = this.updateMyInfo.bind(this);
  }

  async componentDidMount() { }
  componentWillUnmount() { }

  handleChange(event, prop) {
    this.setState({ [prop]: event.target.value });
  }

  async updateMyInfo() {
    let password = this.state.password.trim();
    let passwordConfirm = this.state.passwordConfirm.trim();

    const chkRst = CheckHandler.checkParams([
      {
        key: "用户密码",
        value: password,
        notNull: false,
        type: "strongPwd",
        minLength: 8,
        maxLength: 20,
      },
      {
        key: "再次输入密码",
        value: passwordConfirm,
        notNull: false,
        type: "strongPwd",
        minLength: 8,
        maxLength: 20,
      },
    ]);

    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    if (password === '') {
      store.openMessageDialogOpen('密码不能为空！');
      return;
    }

    if (password !== passwordConfirm) {
      store.openMessageDialogOpen('密码不一致，请重新输入！');
      return;
    }

    // 密码加密
    if (password) password = sha3_512(password);

    const rst = await updateMyInfo({ password, uuid: store.user.uuid });
    console.log(`----- rst of updateMyInfo: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "更新失败");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen("更新成功，请重新登陆");
      store.userExist();
      return true;
    }
  }

  render() {
    if (!getIfFuncAuthorized('个人信息维护')) {
      return (<>权限不足</>);
    }
    const { classes } = this.props;
    console.log(`----- this.state: `, this.state);
    if (!store.user.phone) return (<></>);
    return (
      <div className={classes.root}>
        <>
          <Typography variant="h5" gutterBottom>
            用户管理
          </Typography>
          <ITextField
            margin="dense"
            id="phone"
            label="手机号码"
            fullWidth
            ivalue={store.user.phone}
            type="phone"
            maxLength="11"
            notNull
            disabled
          />
          <ITextField
            margin="dense"
            id="password"
            label="用户密码"
            fullWidth
            ivalue={this.state.password}
            onChange={(e) => this.handleChange(e, "password")}
            type="strongPwd"
            maxLength="20"
            notNull={false}
          />
          <ITextField
            margin="dense"
            id="passwordConfirm"
            label="再次输入用户密码"
            fullWidth
            ivalue={this.state.passwordConfirm}
            onChange={(e) => this.handleChange(e, "passwordConfirm")}
            type="strongPwd"
            maxLength="20"
            notNull={false}
          />
          <ITextField
            margin="dense"
            id="userName"
            label="用户姓名"
            fullWidth
            ivalue={store.user.memname}
            onChange={(e) => this.handleChange(e, "userName")}
            type="text"
            maxLength="20"
            notNull
            disabled
          />
          <ITextField
            margin="dense"
            id="roleTypeDesc"
            label="用户类型"
            fullWidth
            ivalue={store.user.rolename}
            type="text"
            maxLength="20"
            disabled
          />
          {/* <ITextField
            margin="dense"
            id="name"
            label="备注信息"
            fullWidth
            ivalue={store.user.remark}
            type="text"
            maxLength="20"
          /> */}
          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={() => this.updateMyInfo()}
          >
            确认修改
          </Button>
        </>
      </div>
    );
  }
}

const UserInfoManagement = observer(UserInfoManagementInner);

UserInfoManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UserInfoManagement);
